/**
 * Geerate URL query string
 *
 * @param {{[key: string]: string | number | Array<number | string> | undefined | boolean}} obj
 * @returns {string}
 *
 * @example
 *  {count: 1} ?count=1
 *  {state: ['active','deleted'] } ?state=active%2Cdeleted
 */
const generateQuery = (obj: {
  [key: string]: string | number | Array<number | string> | undefined | boolean;
}): string => {
  if (!Object.keys(obj).length) return '';
  Object.keys(obj).forEach((k) => obj[k] === undefined && delete obj[k]);
  const query = Object.keys(obj)
    .map((k) => {
      const value = obj[k];
      if (Array.isArray(value)) {
        obj[k] = value.join(',');
      }
      return k;
    })
    .map(
      (k) =>
        encodeURIComponent(k) +
        '=' +
        encodeURIComponent(obj[k] as string | number)
    )
    .join('&');
  return '?' + query;
};

export default generateQuery;
